import { useTranslation } from "react-i18next";
import styles from "./TermsFragment.module.css";
import Card from "../../common/Card";

const TermsFragment = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<Card title={t("terms.card.title")}>
				<ol className={styles.rulesList}>
					<li dangerouslySetInnerHTML={{ __html: t("terms.term1") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term2") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term3") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term4") }} />
					<li>
						<span dangerouslySetInnerHTML={{ __html: t("terms.term5") }} />
						<ol className={styles.nestedList} type="i">
							<li dangerouslySetInnerHTML={{ __html: t("terms.term5.i") }} />
							<li dangerouslySetInnerHTML={{ __html: t("terms.term5.ii") }} />
							<li dangerouslySetInnerHTML={{ __html: t("terms.term5.iii") }} />
						</ol>
					</li>
					<li dangerouslySetInnerHTML={{ __html: t("terms.term6") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term7") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term8") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term9") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term10") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term11") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term12") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term13") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term14") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term15") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term16") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term17") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term18") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term19") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term20") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term21") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term22") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term23") }} />
					<li dangerouslySetInnerHTML={{ __html: t("terms.term24") }} />
				</ol>
			</Card>
		</div>
	);
};

export default TermsFragment;
